import { Virtue } from "../../modules/virtue"
import { assertIsDefined } from "../../modules/helpers"

export type State = {
  readonly markedVirtues: string[]
  readonly type: Type
  readonly userEmail: string
  readonly virtueIndex: number
  readonly virtues: Virtue[]
}

export enum EventType {
  NEXT_EVENT,
  PREVIOUS_EVENT,
  TOGGLE_DOT_EVENT,
}

export enum Type {
  INITIAL,
  REVIEW,
  LAST,
  SUBMIT,
  CANCEL,
}

export function getCurrentVirtue(state: State): Virtue {
  const virtues = state.virtues
  const index = state.virtueIndex
  const virtue = virtues.at(index)
  assertIsDefined(virtue)
  return virtue
}

export function initialState(
  virtues: Virtue[],
  markedVirtues: string[],
  userEmail: string,
): State {
  const state: State = {
    markedVirtues,
    type: Type.INITIAL,
    userEmail,
    virtueIndex: 0,
    virtues,
  }
  switch (virtues.length) {
    case 0:
      return {
        ...state,
        type: Type.CANCEL,
      }
    case 1:
      return {
        ...state,
        type: Type.LAST,
      }
    default:
      return {
        ...state,
        type: Type.INITIAL,
      }
  }
}

export function marked(virtue: Virtue, state: State): boolean {
  return state.markedVirtues.find((name) => name == virtue.name) != undefined
}

export function nextState(event: EventType, state: State): State {
  const virtueIndex = getVirtueIndex(state)
  switch (event) {
    case EventType.NEXT_EVENT:
      if (virtueIndex == state.virtues.length - 1) {
        return {
          ...state,
          type: Type.SUBMIT,
        }
      } else if (virtueIndex == state.virtues.length - 2) {
        return {
          ...state,
          type: Type.LAST,
          virtueIndex: virtueIndex + 1,
        }
      } else {
        return {
          ...state,
          type: Type.REVIEW,
          virtueIndex: virtueIndex + 1,
        }
      }
    case EventType.PREVIOUS_EVENT:
      if (virtueIndex == 0) {
        return {
          ...state,
          type: Type.CANCEL,
        }
      } else if (virtueIndex == 1) {
        return {
          ...state,
          type: Type.INITIAL,
          virtueIndex: virtueIndex - 1,
        }
      } else {
        return {
          ...state,
          type: Type.REVIEW,
          virtueIndex: virtueIndex - 1,
        }
      }
    case EventType.TOGGLE_DOT_EVENT: {
      const virtue = getCurrentVirtue(state)
      const markedVirtues = state.markedVirtues
      toggleVirtue(markedVirtues, virtue)
      return {
        ...state,
        markedVirtues,
      }
    }
  }
}

export function getMarkedVirtues(state: State): string[] {
  return state.markedVirtues
}

export function getUserEmail(state: State) {
  return state.userEmail
}

function getVirtueIndex(state: State) {
  return state.virtueIndex
}

// Once we start using immutable data structure we can make this more pure
function toggleVirtue(markedVirtues: string[], virtue: Virtue): void {
  const index = markedVirtues.findIndex((name) => name == virtue.name)
  if (index < 0) {
    markedVirtues.push(virtue.name)
  } else {
    markedVirtues.splice(index, 1)
  }
}
